// ***************************************************************************
//  Please keep this file alphabetized for easier maintenance and readability
// ***************************************************************************

export enum AiConversationSummaryEvents {
  Open = 'ai_conversation_summary_opened',
  Close = 'ai_conversation_summary_closed',
  PositiveFeedback = 'ai_conversation_summary_positive_feedback',
  NegativeFeedback = 'ai_conversation_summary_negative_feedback',
  HideButton = 'ai_conversation_summary_hide_button',
}

export enum AiMemoEvents {
  Record = 'ai_memo_record_clicked',
  SummaryOpen = 'ai_memo_summary_opened',
  Download = 'ai_memo_download_clicked',
}

export enum AiRecapEvents {
  Download = 'ai_recap_download_click',
  IsSOAP = 'ai_recap_soap_selected',
  Start = 'ai_recap_start_clicked',
  Pause = 'ai_recap_pause_clicked',
  Resume = 'ai_recap_resume_clicked',
  Done = 'ai_recap_done_clicked',
  RetryUpload = 'ai_recap_retry_upload_clicked',
  PositiveFeedback = 'ai_recap_positive_feedback',
  NegativeFeedback = 'ai_recap_negative_feedback',
}

export enum AiSuggestEvents {
  Open = 'ai_suggest_opened',
  Insert = 'ai_suggest_insert_clicked',
  Retry = 'ai_suggest_try_again_clicked',
}

export enum AppointmentEvents {
  NavClick = 'appointments_nav_click',
  PageViewed = 'appointments_page_viewed',
}

export enum AutomationEvents {
  NavClick = 'automation_nav_click',
  PageViewed = 'automation_page_viewed',
}

export enum BoardEvents {
  ConversationOverlay = 'board_conversation_overlay',
  CustomDateRangeApplied = 'board_custom_date_range_applied',
  NavClick = 'board_nav_click',
  QuickSelectDateRangeApplied = 'board_quick_select_date_range_applied',
  PageViewed = 'board_page_viewed',
}

export enum CareMembershipEvents {
  FinancialReportView = 'membership_financial_report_view',
  ManageBackClick = 'membership_manage_back_click',
  ManageCalculatorSkipped = 'membership_manage_calculator_skipped',
  ManageClose = 'membership_manage_close',
  ManageDownloadSummaryClick = 'membership_manage_download_summary_click',
  ManageGetHelpClick = 'membership_manage_get_help_click',
  ManageStart = 'membership_manage_start',
  ManageSubmit = 'membership_manage_submit',
  ManageSubmitCancellation = 'membership_manage_submit_cancellation',
  ManageSuccessDismiss = 'membership_manage_success_dismiss',
  ManageToggleAdjustment = 'membership_manage_toggle_adjustment',
  ManageToggleFees = 'membership_manage_toggle_fees',
  ManageToggleMemberSavings = 'membership_manage_toggle_member_savings',
  ManageViewCalculatorStep = 'membership_manage_view_calculator_step',
  ManageViewCancelStep = 'membership_manage_view_cancel_step',
  ManageViewGetHelpStep = 'membership_manage_view_get_help_step',
  PetPortalLinkCtaClick = 'membership_tab_pet_portal_link_cta',
  PaymentsReportExclude = 'membership_payments_report_exclude',
  PaymentsReportInclude = 'membership_payments_report_include',
  ViewBenefits = 'membership_view_benefits',
  WizardClose = 'membership_wizard_close',
  WizardComplete = 'membership_wizard_complete',
  WizardStart = 'membership_wizard_start',
}

export enum ChurnZeroEvents {
  ErrorOnLoad = 'churnzero_success_hub_error_on_load',
  FailedToLoad = 'churnzero_success_hub_failed_to_load',
  Loaded = 'churnzero_success_hub_loaded',
  ChatWithUsClicked = 'success_hub_chat_with_us_clicked',
}

export enum ConversationEvents {
  AutomationRunCollapse = 'conversations_collapse_automation_run',
  AutomationRunExpand = 'conversations_expand_automation_run',
  AutomationRunReset = 'conversations_clinic_reset_automation_run',
  AutomationRunSubmit = 'conversations_clinic_submit_automation_run',
  ChannelAddNewAssignee = 'conversations_add_new_assignee',
  ChannelAddNewPatient = 'conversations_add_new_patient',
  ChannelAddNewClient = 'conversations_add_new_client',
  ChannelRemoveClient = 'conversations_remove_client',
  ChannelAttachmentSent = 'conversations_channel_attachment_sent',
  ChannelDeleteMessage = 'conversations_channel_delete_message',
  ChannelDetailsModalOpen = 'conversation_modal_open',
  ChannelDetailsModalTabApptClick = 'conversation_modal_tab_appt_click',
  ChannelDetailsModalTabFormClick = 'conversation_modal_tab_form_click',
  ChannelDetailsModalTabParticipantsClick = 'conversation_modal_tab_partic_click',
  ChannelEmojiDrawerOpen = 'conversations_emoji_drawer_open',
  ChannelEmojiSelectedFromDrawer = 'conversations_emoji_selected_from_drawer',
  ChannelEmojiTypedManually = 'conversations_emoji_typed_manually',
  ChannelGifsDrawerOpen = 'conversations_gifs_drawer_open',
  ChannelGifSelectedFromDrawer = 'conversations_gif_selected_from_drawer',
  ChannelLastMessageMismatch = 'conversations_last_message_mismatch',
  ChannelListMarkAllAsRead = 'conversations_list_mark_all_as_read',
  ChannelListPinToggle = 'conversations_list_pinned_conversation',
  ChannelMessageSent = 'conversations_channel_message_sent',
  ChannelNoteSent = 'conversations_channel_note_sent',
  ChannelQuickEmojiSelected = 'conversations_quick_emoji_selected',
  ChannelSearchList = 'conversations_list_channel_search',
  ChannelSearchListOpened = 'conversations_list_channel_search_opened',
  ChannelUserMentioned = 'conversations_user_mentioned',
  ChannelShortcutUsed = 'conversations_channel_shortcut_used',
  ChannelInvalidShortcutUsed = 'conversations_channel_invalid_shortcut_used',
  ChannelComposerExpanded = 'conversations_channel_composer_expanded',
  ChannelComposerCollapsed = 'conversations_channel_composer_collapsed',
  FilterApplied = 'conversations_list_filter_applied',
  FilterByAll = 'conversations_list_filter_by_all',
  FilterByUnread = 'conversations_list_filter_by_unread',
  FilterDraftSaved = 'conversations_list_filter_draft_saved',
  FilterRemoved = 'conversations_list_filter_removed',
  FilterSelected = 'conversations_list_filter_selected',
  FilterShared = 'conversations_list_filter_shared',
  FilterShowArchivedToggled = 'conversations_list_filter_show_archive_toggled',
  FiltersEditViewed = 'conversations_list_filters_edit_viewed',
  FiltersViewed = 'conversations_list_filters_viewed',
  FormDownloadPdf = 'conversations_download_form_pdf',
  FormExportToPims = 'conversations_export_form_to_pims',
  FormExportToPimsMultiPet = 'conversations_export_form_to_pims_multi_pet',
  FormSent = 'conversations_form_sent',
  InvoiceAttachToMessage = 'conversations_invoice_attach_to_message',
  InvoiceCancelled = 'conversations_cancel_invoice',
  InvoiceViewPreview = 'conversations_invoice_preview_view',
  InvoiceManuallyLinkedBenefit = 'conversations_manually_linked_benefit',
  InvoicePreviewBenefitChanged = 'conversations_invoice_preview_benefit_changed',
  InvoicePreviewBenefitManuallyAdded = 'conversations_invoice_preview_benefit_manually_added',
  InvoicePreviewClearServiceCode = 'conversations_invoice_preview_clear_service_code',
  InvoicePreviewLineItemAdded = 'conversations_invoice_preview_line_item_added',
  InvoicePreviewLineItemDeleted = 'conversations_invoice_preview_line_item_deleted',
  InvoicePreviewSearchServiceCode = 'conversations_invoice_preview_search_service_code',
  InvoicePreviewSelectServiceCode = 'conversations_invoice_preview_Select_service_code',
  InvoiceRefreshPimsBalance = 'conversations_invoice_preview_refresh_pims_balance',
  InvoiceSyncBenegitUsageToPims = 'conversations_invoice_preview_sync_benefit_usage_to_pims',
  InvoicePayNow = 'conversations_invoice_preview_pay_now',
  InvoiceSent = 'conversations_invoice_sent',
  InvoiceTogglePetDetails = 'conversations_view_pet_details',
  InvoiceViewInTerminal = 'conversations_view_invoice_in_terminal',
  InvoiceViewItemizedReceipt = 'conversations_view_itemized_receipt',
  LoyaltyAttachPimsBalance = 'conversations_loyalty_attach_pims_balance',
  MessageTemplateSelected = 'conversations_message_template_selected',
  NavClick = 'conversations_nav_click',
  PageViewed = 'conversation_page_viewed',
}

export enum CustomSnoozeModalEvents {
  SnoozeSettingsSaved = 'custom_snooze_modal_snooze_settings_saved',
  SnoozeSettingsCancelled = 'custom_snooze_modal_snooze_settings_cancelled',
  ViewSnoozeModal = 'custom_snooze_modal_view_snooze_modal',
  EditSnoozeAmount = 'custom_snooze_modal_edit_snooze_amount',
  TurnOffSnooze = 'custom_snooze_modal_turn_off_snooze',
}

export enum EmailCampaignEvents {
  BestPracticesClick = 'email_campaign_best_practices_click',
  TemplateSelected = 'email_campaign_template_selected',
  CustomListDelete = 'email_campaigns_custom_list_delete',
  CustomUpload = 'email_campaigns_custom_upload',
  CustomUploadFailure = 'email_campaigns_custom_upload_failure',
  NavClick = 'email_campaigns_nav_click',
  PageViewed = 'email_campaigns_page_viewed',
  RecipientLimitReached = 'email_campaigns_recipient_limit_reached',
  RejectedRecipients = 'email_campaigns_rejected_recipients',
}

export enum EmailEditorEvents {
  DesignLoaded = 'email_editor_design_loaded',
  DesignPreviewed = 'email_editor_design_previewed',
  DesignPublished = 'email_editor_design_published',
  DesignReady = 'email_editor_design_ready',
  DesignReverted = 'email_editor_design_reverted',
  DesignSaved = 'email_editor_design_saved',
  ImageUploaded = 'email_editor_image_uploaded',
}

export enum ServiceReminderEvents {
  DisableServiceReminders = 'disable_service_reminders',
  EditEmailTemplateClick = 'edit_email_template_click',
  EnableServiceReminders = 'enable_service_reminders',
  ServiceRemindersFormUpdated = 'service_reminders_form_updated',
  VisitSettingsPage = 'visit_service_reminders_settings_page',
  ViewAppointmentRequestFormClick = 'view_appointment_request_form_click',
}

export enum FormsEvents {
  NavClick = 'forms_nav_click',
  PageViewed = 'forms_page_viewed',
  NameChanged = 'forms_form_name_changed',
  IntroMessageChanged = 'forms_form_intro_message_changed',
  WildcardAdded = 'forms_form_wildcard_added',
  UploadForms = 'forms_upload_forms',
  AddBlankForm = 'forms_add_blank_form',
  AddTemplateForm = 'forms_add_template_form',
  AddNewForm = 'forms_add_new_form',
  QuestionAdded = 'forms_form_question_added',
}

export enum GeneralEvents {
  ErrorBoundaryFallbackTriggered = 'error_boundary_fallback_triggered',
  UiRefreshedFromNotification = 'ui_refreshed_from_notification',
  LocalStorageCleared = 'local_storage_cleared',
  ViewUserProfile = 'view_user_profile',
  ViewMyNotificationSettings = 'view_my_notification_settings',
  SnoozeNotifications = 'snooze_notifications',
  PimsSyncRefresh = 'pims_sync_refresh',
}

export enum LoginEvents {
  AcceptInvitation = 'user_accept_invitation',
  Logout = 'logout',
}

export enum LoyaltyEvents {
  ClaimModalConfirm = 'loyalty_claim_modal_confirm',
  ClaimModalDismiss = 'loyalty_claim_modal_dismiss',
  EarnVirtualCurrency = 'earn_virtual_currency',
  EligibleItemsCheckboxClick = 'loyalty_eligible_items_checkbox_click',
  FulfillModalConfirm = 'loyalty_fulfill_modal_confirm',
  FulfillModalDismiss = 'loyalty_fulfill_modal_dismiss',
  NavClick = 'loyalty_nav_click',
  RewardsAddNewClick = 'loyalty_rewards_add_new_click',
  RewardsDeleteClick = 'loyalty_rewards_delete_click',
  RewardsEditClick = 'loyalty_rewards_edit_click',
  RewardsToggle = 'loyalty_rewards_toggle',
  SettingsView = 'loyalty_settings_view',
  SidepanelAddPointsClick = 'loyalty_sidepanel_add_points_click',
  SidepanelClaimRewardClick = 'loyalty_sidepanel_claim_reward_click',
  SidepanelCurrentRewards = 'loyalty_sidepanel_current_rewards',
  SidepanelFulfillRewardClick = 'loyalty_sidepanel_fulfill_reward_click',
  SidepanelRewardsHistory = 'loyalty_sidepanel_rewards_history',
  SidepanelViewRewardsList = 'loyalty_sidepanel_view_rewards_list',
  SpendVirtualCurrency = 'spend_virtual_currency',
  PageViewed = 'loyalty_page_viewed',
}

export enum MassTextAlertEvents {
  EditSelectedDateRange = 'mass_text_alert_edit_selected_date_range',
  SetCustomDateRange = 'mass_text_alert_set_custom_date_range',
}

export enum MergeProfileEvents {
  MergeLoyaltyPointsAttempt = 'merge_profile_merge_loyalty_points_attempt',
  MergeCareMembershipAttempt = 'merge_profile_merge_care_membership_attempt',
  EditSendSurveyToggle = 'merge_profile_edit_send_survey_toggle',
  ConfirmMergedInfo = 'merge_profile_confirm_merged_info',
  CancelMergedInfo = 'merge_profile_cancel_merged_info',
  MergePhoneNumbers = 'merge_profile_merge_phone_numbers',
  SetPrimaryPhoneNumber = 'merge_profile_set_primary_phone_number',
  SetContactMethod = 'merge_profile_set_contact_method',
  SearchProfilesStep = 'merge_profile_search_profiles_step',
  SelectInfoStep = 'merge_profile_select_info_step',
  BackToSearchProfileStep = 'merge_profile_back_to_search_profiles_step',
  BackToSelectInfoStep = 'merge_profile_back_to_select_info_step',
}

export enum MessageTemplateEvents {
  NavClick = 'message_templates_nav_click',
  PageViewed = 'message_templates_page_viewed',
  TemplateCreated = 'message_templates_template_created',
  TemplateArchived = 'message_templates_template_archived',
  TemplateUnarchived = 'message_templates_template_unarchived',
}

export enum PhonCallPopoverEvents {
  ViewPopover = 'phone_call_popover_view',
}

export enum PhoneCallRecordingEvents {
  RecordingPaused = 'phone_call_recording_paused',
  RecordingResumed = 'phone_call_recording_resumed',
  RecordingStarted = 'phone_call_recording_started',
}

export enum ReportingEvents {
  NavClick = 'reporting_nav_click',
  PageViewed = 'reporting_page_viewed',
}

export enum ReportingPaymentsReportEvents {
  FilterByTransactionName = 'reporting_filter_by_transaction_name',
  FilterByTransactionCardBrand = 'reporting_filter_by_transaction_card_brand',
  FilterByTransactionCardType = 'reporting_filter_by_transaction_card_type',
  FilterByDisputeStatus = 'reporting_filter_by_dispute_status',
  PayEodBatchCreate = 'pay_eod_batch_create',
  PayEodCancel = 'pay_eod_cancel',
  PayEodStart = 'pay_eod_start',
}

export enum ReportingCallReportEvents {
  TranscriptClick = 'call_report_transcript_click',
}

export enum SettingsEvents {
  NavClick = 'settings_nav_click',
  PageViewed = 'settings_page_viewed',
}

export enum SettingsClincHoursEvents {
  TimeZoneSelected = 'settings_clinic_hours_time_zone_selected',
  EditEmergencyClinicModal = 'settings_clinic_hours_edit_emergency_clinic_modal',
  DeleteEmergencyClinic = 'settings_clinic_hours_delete_emergency_clinic',
  EditEmergencyContactPhone = 'settings_clinic_hours_edit_emergency_clinic_phone',
  EditEmergencyClinicName = 'settings_clinic_hours_edit_emergency_clinic_name',
  EditEmergencyClinicAddress = 'settings_clinic_hours_edit_emergency_clinic_address',
  EditEmergencyClinicCity = 'settings_clinic_hours_edit_emergency_clinic_city',
  EditEmergencyClinicState = 'settings_clinic_hours_edit_emergency_clinic_state',
  EditEmergenctClinicZip = 'settings_clinic_hours_edit_emergency_clinic_zip',
  SubmitEmergencyClinicInfo = 'settings_clinic_hours_submit_emergency_clinic_info',
  EditOfficeHours = 'settings_clinic_hours_edit_office_hours',
}

export enum SettingsConversationEvents {
  DeleteAutoUpdateStatusRule = 'settings_conversation_delete_auto_update_status_rule',
  AddAutoUpdateStatusRule = 'settings_conversation_add_auto_update_status_rule',
  DeleteStatus = 'settings_conversation_delete_status',
  AddStatus = 'settings_conversation_add_status',
  UpdateStatusOrder = 'settings_conversation_update_status_order',
  EditStatusName = 'settings_conversation_edit_status_name',
}

export enum SettingsGeneralInfoEvents {
  EditClinicLogo = 'settings_general_info_edit_clinic_logo',
}

export enum SettingsMyNotificationEvents {
  EnableAllEmailNotifs = 'settings_my_notifications_enable_all_email_notifs',
  EnableAllTextNotifs = 'settings_my_notifications_enable_all_text_notifs',
  EnableEmailNotifsPerFeature = 'settings_my_notifications_enable_email_notifs_per_feature',
  EnableTextNotifsPerFeature = 'settings_my_notifications_enable_text_notifs_per_feature',
}

export enum SettingsMyProfileEvents {
  EditUserEmailConfirmed = 'settings_my_profile_edit_user_email_confirmed',
  EnterNewuserEmail = 'settings_my_profile_enter_new_user_email',
  ConfirmNewUserEmail = 'settings_my_profile_confirm_new_user_email',
  CancelEditUserEmail = 'settings_my_profile_cancel_edit_user_email',
  EditUserPasswordConfirmed = 'settings_my_profile_edit_user_password_confirmed',
  EnterCurrentPassword = 'settings_my_profile_enter_current_password',
  EnterNewPassword = 'settings_my_profile_enter_new_password',
  ConfirmNewPassword = 'settings_my_profile_confirm_new_password',
  CancelEditUserPassword = 'settings_my_profile_cancel_edit_user_password',
  EditUserAvatar = 'settings_my_profile_edit_user_avatar',
  ViewEditEmailModal = 'settings_my_profile_view_edit_email_modal',
  ViewEditPasswordModal = 'settings_my_profile_view_edit_password_modal',
  EditUserPrefix = 'settings_my_profile_edit_user_prefix',
  EditUserFirstName = 'settings_my_profile_edit_user_first_name',
  EditUserLastName = 'settings_my_profile_edit_user_last_name',
  EditUserSuffix = 'settings_my_profile_edit_user_suffix',
  EditUserDisplayName = 'settings_my_profile_edit_user_display_name',
  EditUserPhone = 'settings_my_profile_edit_user_phone',
}

export enum SettingsOttoLabsEvents {
  ToggleDarkMode = 'settings_otto_labs_toggle_dark_mode',
  ToggleDictation = 'settings_otto_labs_toggle_dictation',
}

export enum SettingsPaymentsEvents {
  PaymentIntegrationInitiatedSidePanel = 'settings_payment_initiated_from_side_panel',
  PaymentsSupportRequestInitiatedSidePanel = 'settings_payments_support_request_initiated_from_side_panel',
  PaymentIntegrationInitiatedMessageComposer = 'settings_payment_initiated_from_message_composer',
  WriteBackConfigurationInitiatedSidePanel = 'settings_write_back_config_initiated_from_side_panel',
  Initiated = 'payments_integration_payment_integration_initiated',
  BitwerxInstallationSubmitted = 'payments_integration_contact_for_bitwerx_installation_submitted',
  BitwerxInstallationCanceled = 'payments_integration_contact_for_bitwerx_installation_canceled',
  EmployeeAddition = 'payments_integration_employee_addition_in_pims_instructions',
  PaymentTypeAddition = 'payments_integration_payment_type_addition_in_pims_instructions',
  SinglePaymentSelected = 'payments_integration_single_payment_type_selected',
  ConfigurationComplete = 'payments_integration_configuration_complete',
  CardSelected = 'payments_integration_card_type_selected',
  EmployeeSelected = 'payments_integration_employee_selected',
  StripeAccountCreation = 'payments_setup_stripe_account_creation',
  StripeAccountUpdates = 'payments_setup_stripe_account_updates',
}

export enum SettingsRequestWidgetEvents {
  AddNewRequest = 'settings__add_new_request',
  CancelRequest = 'settings_request_widget_cancel',
  AddAssignee = 'settings_request_widget_request_add_assignee',
  SelectRequestType = 'settings_request_widget_request_select_request_type',
  SelectRequestVisibility = 'settings_request_widget_request_select_request_visibility',
  AddDisplayName = 'settings_request_widget_request_add_display_name',
  AddForm = 'settings_request_widget_request_add_form',
  AddConversationStatus = 'settings_request_widget_request_add_conversation_status',
  SendCodeToDev = 'settings_request_widget_send_code_to_dev',
  UpdateWidgetSettings = 'settings_request_widget_update_settings',
  WelcomeMessage = 'website_widget_welcome_message',
  WhiteLabelUrls = 'website_widget_add_whitelist_url_clicked',
  EnableWidget = 'website_widget_enable_widget',
  SaveSettingClicked = 'website_widget_save_settings_clicked',
  CopyClicked = 'website_widget_copy_clicked',
  SendWebDeveloperClicked = 'website_widget_settings_send_to_web_developer_button_clicked',
  AddNewClicked = 'website_widget_add_new_clicked',
  UrlEntered = 'website_widget_whitelist_url_entered',
}

export enum SettingsServiceReminderEvents {
  TogglePostcards = 'settings_service_reminder_toggle_postcards',
}

export enum SettingsSmsEvents {
  AddBlockedNumber = 'flow_settings_add_blocked_number',
  SubmitBlockedNumber = 'flow_settings_submit_blocked_number',
  View = 'flow_text_messaging_settings',
}

export enum SettingsSyncStatusEvents {
  ViewKnowledgeBaseArticle = 'settings_sync_status_view_knowledge_base_article',
  ViewSettingsPageFromAlert = 'settings_sync_status_view_settings_page_from_alert',
  SyncOutageOccurred = 'settings_sync_status_sync_outage_occurred',
}

export enum SettingsTeamEvents {
  ViewEditUserModal = 'settings_team_view_edit_user_modal',
  ViewDeleteUserModal = 'settings_team_view_delete_user_modal',
}

export enum SidePanelAppointmentsEvents {
  AddNewAppointment = 'side_panel_appointments_add_new_appointment',
}

export enum SidePanelClientProfileEvents {
  ReservedPhoneNumberEntered = 'side_panel_client_profile_reserved_phone_number_entered',
  InvalidPhoneNumberEntered = 'side_panel_client_profile_invalid_phone_number_entered',
  DuplicatePhoneNumberEntered = 'side_panel_client_profile_duplicate_phone_number_entered',
  PhoneNumberAdded = 'side_panel_client_profile_phone_number_added',
  ViewConversation = 'side_panel_client_profile_view_conversation',
  JoinSelectedConversation = 'side_panel_client_profile_join_selected_conversation',
  MergeLoyaltyPointsAttempt = 'side_panel_client_profile_merge_loyalty_points_attempt',
  MergeCareMembershipAttempt = 'side_panel_client_profile_merge_care_membership_attempt',
  ViewMergeProfilesModal = 'side_panel_client_profile_view_merge_profiles_modal',
  EditPrimaryPhoneNumber = 'side_panel_client_profile_edit_primary_phone_number',
  EditEmailAddress = 'side_panel_client_profile_edit_email_address',
}

export enum SidePanelInvoicingEvents {
  RefundInitiated = 'side_panel_invoicing_refund_initiated',
  InvoiceRefreshPimsBalance = 'side_panel_invoicing_refresh_pims_balance',
  InvoiceRefreshInvoices = 'side_panel_invoicing_refresh_invoices',
  SendInvoiceToTerminal = 'side_panel_invoicing_send_invoice_to_terminal',
  TerminalInvoiceRetryProcessing = 'side_panel_invoicing_terminal_invoice_retry_process',
  TerminalInvoiceSuccess = 'side_panel_invoicing_terminal_invoice_success',
  TerminalInvoiceFailed = 'side_panel_invoicing_terminal_invoice_failed',
  TerminalInvoiceCancelled = 'side_panel_invoicing_terminal_invoice_cancelled',
  DigitalInvoiceError = 'side_panel_invoicing_digital_invoice_error',
  PaymentIntegrationInitiatedSidePanel = 'invoicing_payment_integration_is_initiated_from_invoicing_side_panel',
  PaymentIntegrationInitiatedMessageComposer = 'invoicing_payment_integration_is_initiated_from_message_composer',
  WriteBackConfigurationInitiatedSidePanel = 'invoicing_write_back_configuration_is_initiated_from_invoicing_side_panel',
}

export enum SidePanelPetProfileEvents {
  PetPortalLinkClick = 'side_panel_pet_profile_copy_portal_link',
  ViewAppointment = 'side_panel_pet_profile_view_appointment',
}

export enum SurveyEvents {
  NavClick = 'surveys_nav_click',
  PageViewed = 'surveys_page_viewed',
  EditSurveySendStatusChange = 'survey_edit_survey_send_status_change',
  SurveySettingsUpdated = 'survey_settings_updated',
}

export enum TasksEvents {
  AssigneesUpdated = 'task_assignees_updated',
  CustomTaskAddNewButtonClicked = 'task_custom_task_add_new_button_clicked',
  CustomTaskCreated = 'task_custom_task_created',
  CustomTaskDeleted = 'task_custom_task_deleted',
  CustomTaskEdited = 'task_custom_task_edited',
  FilterSelectionApplied = 'task_filter_selection_applied',
  ListCreated = 'task_list_created',
  ListDeleted = 'task_list_deleted',
  ListEdited = 'task_list_edited',
  MarkedCompleted = 'task_marked_completed',
  MarkedUndone = 'task_marked_undone',
  MessageButtonClicked = 'task_message_button_clicked',
  NavClick = 'task_nav_click',
  PageViewed = 'task_page_viewed',
  StatusUpdated = 'task_status_updated',
  NeedsAttentionTabViewed = 'task_needs_attention_tab_viewed',
  CompletedTabViewed = 'task_completed_tab_viewed',
}

export enum TeamChatEvents {
  NavClick = 'team_chat_nav_click',
  PageViewed = 'team_chat_page_viewed',
  ChannelAddAssignee = 'team_chat_channel_add_assignee',
  PublicChannelCreated = 'team_chat_public_channel_created',
  DirectMessageChannelCreated = 'team_chat_direct_message_channel_created',
}

export enum TrupanionEvents {
  ViewModal = 'trupanion_view_modal',
  OfferEligible = 'trupanion_exam_day_offer_eligible',
  OfferViewClicked = 'trupanion_exam_day_offer_view_click',
  OfferSendClicked = 'trupanion_exam_day_offer_send_click',
}

export enum VideoCallEvents {
  CallEnded = 'video_call_ended',
  CallStarted = 'video_call_started',
  ViewVideoRatingModal = 'video_call_view_video_rating_modal',
}

export type EventName =
  | AiConversationSummaryEvents
  | AiMemoEvents
  | AiRecapEvents
  | AiSuggestEvents
  | AppointmentEvents
  | AutomationEvents
  | BoardEvents
  | CareMembershipEvents
  | ChurnZeroEvents
  | ConversationEvents
  | CustomSnoozeModalEvents
  | EmailCampaignEvents
  | EmailEditorEvents
  | ServiceReminderEvents
  | FormsEvents
  | GeneralEvents
  | LoginEvents
  | LoyaltyEvents
  | MassTextAlertEvents
  | MergeProfileEvents
  | MessageTemplateEvents
  | PhonCallPopoverEvents
  | PhoneCallRecordingEvents
  | ReportingCallReportEvents
  | ReportingEvents
  | ReportingPaymentsReportEvents
  | SettingsClincHoursEvents
  | SettingsConversationEvents
  | SettingsEvents
  | SettingsGeneralInfoEvents
  | SettingsMyNotificationEvents
  | SettingsMyProfileEvents
  | SettingsOttoLabsEvents
  | SettingsPaymentsEvents
  | SettingsRequestWidgetEvents
  | SettingsServiceReminderEvents
  | SettingsSmsEvents
  | SettingsSyncStatusEvents
  | SettingsTeamEvents
  | SidePanelAppointmentsEvents
  | SidePanelClientProfileEvents
  | SidePanelInvoicingEvents
  | SidePanelPetProfileEvents
  | SurveyEvents
  | TasksEvents
  | TeamChatEvents
  | TrupanionEvents
  | VideoCallEvents;

// ***************************************************************************
//  Please keep this file alphabetized for easier maintenance and readability
// ***************************************************************************
